module.exports = __webpack_public_path__ + "img/microservices-http.18cf7019.svg";